import {formatCurrency} from 'mc/lib/utils/commons';

export const MODULE_CODE_POP = "POP";

export function formatCurrencyWithoutSymbol(castka) {
    return formatCurrency(castka, {includeCurrencySymbol: false});
}

export function formatBoolean(value) {
    if (typeof value === 'boolean') {
        return value ? 'Ano' : 'Ne';
    }
    return value;
}
